import styled, { css } from "styled-components";
import { BTTO_PROFILE_COLORS } from "@pages/profile-v2/betto/shared/elements";

const isBetto = window.TENANT === "betto";

export const DatePickerWrapper = styled.div`
	display: flex;
	min-width: 160px;
	width: 100%;
	height: ${isBetto ? "44px" : "40px"};
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	border-radius: ${isBetto ? "8px" : "20px"};
	font-size: 10px;
	font-weight: 500;
	line-height: 12px;
	letter-spacing: 0.3px;
`;

export const DatePickerButtonWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: ${isBetto ? "44px" : "40px"};
	max-width: 360px;
	width: 100%;
	padding: 0 14px;
	gap: 8px;
	border-radius: ${isBetto ? "8px" : "25px"};
	background: ${isBetto ? BTTO_PROFILE_COLORS.surfaceRaised : "rgba(0, 0, 0, 0.9)"};
	border: ${isBetto ? `1px solid ${BTTO_PROFILE_COLORS.border}` : "none"};
	cursor: pointer;
	transition:
		background 0.2s ease,
		border-color 0.2s ease;

	${isBetto &&
	css`
		&:hover {
			border-color: ${BTTO_PROFILE_COLORS.borderActive};
			background: ${BTTO_PROFILE_COLORS.surfaceHover};
		}
	`}

	svg path {
		fill: ${isBetto ? BTTO_PROFILE_COLORS.textMuted : "currentColor"};
	}
`;

export const Date = styled.div`
	color: ${isBetto ? BTTO_PROFILE_COLORS.text : "var(--secondary-text-color)"};
	text-align: center;
	font-size: 12px;
	font-weight: ${isBetto ? "500" : "400"};
	line-height: 20px;
	letter-spacing: 0.3px;
	cursor: pointer;
`;

export const DatePickerContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
`;

export const DateTitle = styled.div`
	color: var(--content-text-color);
	text-align: center;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	letter-spacing: 0.75px;
`;
